import { observer } from "mobx-react-lite";
import * as React from "react";
import { NGButton } from "../../../newcomponents/button/Button";
import { NGFormElement } from "../../../newcomponents/ngformelement/ngformelement";
import { getLogsOpenTelemetryData } from "./data/opentelemetry";
import { NGInputListMst } from "../../../newcomponents/inputList/inputListMst";
import { NGInput } from "../../../newcomponents/input/input";

interface Props {
  formPrefix: string;
  opentelemetry: ReturnType<typeof getLogsOpenTelemetryData>;
  onRemove?: any;
}
const OpenTelemetryRaw: React.FC<Props> = ({ formPrefix, opentelemetry, onRemove }) => {
  formPrefix += "-opentelemetry-";

  return (
    <>
      <div style={{ width: 450 }}>
        <NGFormElement
          name={`${formPrefix}endpoint`}
          label={opentelemetry.endpoint.label}
          value={opentelemetry.endpoint.value}
          onChange={opentelemetry.endpoint.setValue}
          required={opentelemetry.endpoint.isRequired}
          error={opentelemetry.endpoint.error}
        />
        <NGInputListMst
          data={opentelemetry.headers}
          firstLabel="Key"
          firstInput={(item) => (
            <NGInput value={item.firstValue} onChange={(e) => item.setFirstValue(e.target.value)} />
          )}
          secondLabel="Value"
          secondInput={(item) => (
            <NGInput value={item.secondValue} onChange={(e) => item.setSecondValue(e.target.value)} />
          )}
          label="Headers"
        />
        <NGFormElement
          name={`${formPrefix}credentials`}
          label={opentelemetry.credentials.label}
          value={opentelemetry.credentials.value}
          onChange={opentelemetry.credentials.setValue}
          as={"kindselect"}
          kind="secret"
          kindSelectProps={{
            queries: [{ property: "type", value: "opaque" }],
          }}
        />
        {onRemove ? (
          <div className="flex justify-end">
            <NGButton style={{ width: 215 }} onClick={() => onRemove()} variant={"danger"}>
              Remove Provider
            </NGButton>
          </div>
        ) : null}
      </div>
    </>
  );
};

export const OpenTelemetry = observer(OpenTelemetryRaw);
